export type PopupCommunicationMessage = PopupPageLoadedMessage;

export interface PopupPageLoadedMessage {
  source: 'popup';
  action: 'loaded';
  timeStamp: number;
}
